const MuiCircularProgressOverrides = {
  MuiCircularProgress: {
    defaultProps: {
      color: 'info'
    }
  }
};

export { MuiCircularProgressOverrides };
